module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/area_an-8d8bac8c7e8d68f968e49805e12c56d6.jpg";